import { debouncer } from "../Utility/utils";

function makeFluid(ft) {
  const stylesToCopy = ["font-weight", "letter-spacing", "font-style", "text-transform"];
  const styles = getComputedStyle(ft);

  const copy = document.createElement("span");
  copy.style.setProperty("visibility", "hidden");
  copy.style.setProperty("white-space", "nowrap");
  copy.style.setProperty("display", "inline-block");

  copy.classList.add(...Array.from(ft.classList).filter((c) => c !== "fluid-text"));

  stylesToCopy.forEach((s) => {
    copy.style.setProperty(s, styles.getPropertyValue(s));
  });

  copy.innerHTML = ft.innerHTML;

  ft.parentNode.append(copy);
  ft.style.setProperty("--computed-font-pct", (ft.parentNode.getBoundingClientRect().width / copy.getBoundingClientRect().width) * 98);
  ft.parentNode.removeChild(copy);
}

function updateFluids() {
  document.querySelectorAll(".fluid-text").forEach((ft) => {
    makeFluid(ft);
  });
}

//INITIALIZE
updateFluids();
// setTimeout(updateFluids, 100);

window.addEventListener("resize", debouncer(updateFluids, 100));

const initializeFluids = function ($block) {
  // For backend, ensure we're targeting the actual block.
  if (!!$block[0]) {
    $block = $block[0];
  }

  // Default Slider Block
  if (!!$block.querySelector(".fluid-text")) {
    updateFluids();
  }
};

// Initialize dynamic block preview (editor).
if (window.acf) {
  window.acf.addAction("render_block_preview/type=hero", initializeFluids);
  window.acf.addAction("render_block_preview/type=fluid-text", initializeFluids);
}
